import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilService } from './util.service';

@Injectable({
    providedIn: 'root',
})
export class APIService {
    private httpOptions = {
        headers: new HttpHeaders({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Content-Type': 'application/json',
        }),
    };

    constructor(private http: HttpClient, private utilService: UtilService) {}

    /**
     * Http Post
     *
     * @param url
     * @param entity
     * @returns observable
     */
    public post(url: string, entity: any): Observable<any> {
        return this.http.post<any>(
            this.utilService.baseUrl + url,
            entity,
            this.httpOptions
        );
    }

    /**
     * Http Get
     *
     * @param url
     * @param params
     * @returns observable
     */
    public get(url: string, params: any): Observable<any> {
        let urlParams = this.utilService.baseUrl + url;
        if (params) {
            urlParams += '?';
            for (const param of params) {
                urlParams += param.name + '=' + param.value + '&';
            }
        }
        return this.http.get<any[]>(urlParams, this.httpOptions);
    }
    /**
     * Http Put
     *
     * @param url
     * @param entity
     * @returns observable
     */
    public put(url: string, entity: any): Observable<any> {
        return this.http.put<any>(
            this.utilService.baseUrl + url,
            entity,
            this.httpOptions
        );
    }
    /**
     * Http Patch
     *
     * @param url
     * @param entity
     * @returns observable
     */
    public patch(url: string, entity: any): Observable<any> {
        return this.http.patch<any>(
            this.utilService.baseUrl + url,
            entity,
            this.httpOptions
        );
    }
    /**
     * Http Delete
     *
     * @param url
     * @returns observable
     */
    public delete(url: string): Observable<any> {
        return this.http.delete<any>(
            this.utilService.baseUrl + url,
            this.httpOptions
        );
    }

    /**
     * Http Get
     *
     * @param url
     * @param params
     * @returns observable
     */
    public download(url: string): Observable<any> {
        const urlParams = this.utilService.baseUrl + url;

        return this.http.get<any[]>(urlParams, {
            headers: new HttpHeaders({
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'Content-Type': 'application/json',
            }),
            responseType: 'blob' as 'json',
        });
    }
    public download2(url: string): Observable<any> {
        const urlParams = this.utilService.fileUrl + url;

        return this.http.get<any[]>(urlParams, {
            headers: new HttpHeaders({
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'Content-Type': 'application/json',
            }),
            responseType: 'blob' as 'json',
        });
    }

    onDownload(path, filename): void {

        this.download2(encodeURIComponent(path)).subscribe({
            next: (response) => {
                const dataType = response.type;
                const binaryData = [];
                binaryData.push(response);
                const downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(
                    new Blob(binaryData, { type: dataType })
                );

                downloadLink.setAttribute('download', filename);

                document.body.appendChild(downloadLink);
                downloadLink.click();
            },
        });
    }
}
